module.exports = __webpack_public_path__ + "linea-ecommerce-10.ffd2088eabba9bda4af6.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-ecommerce-10.eot
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-ecommerce-10.eot
// module chunks = styles